// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Weekday from "../../../domain/types/common/Weekday.bs.js";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_format from "../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as SurgeStrategy from "../../../domain/types/surge/SurgeStrategy.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../domain/repo/CrmRepoManager.bs.js";
import * as SurgeViewUtils from "../SurgeViewUtils.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DateTime$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as SurgeZoneStrategy from "../types/SurgeZoneStrategy.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ModalFooter$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalFooter.bs.js";
import * as FormTitleBar$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormTitleBar.bs.js";
import * as CheckBoxGroup$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/check-box-group/CheckBoxGroup.bs.js";
import * as FormDateInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/deprecated/FormDateInput.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as FormTimeInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/deprecated/FormTimeInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as FormCheckBoxInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormCheckBoxInput.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as FormRadioGroupInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormRadioGroupInput.bs.js";
import * as SuccessInfoComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/success/SuccessInfoComponent.bs.js";
import * as FixedLoadingViewComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/FixedLoadingViewComponent.bs.js";
import * as FormSelectWithCheckboxInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectWithCheckboxInput.bs.js";

function convertTimeToMinutes(timeWindow) {
  var arr = timeWindow.split(":");
  return Math.imul(Caml_format.caml_int_of_string(Caml_array.get(arr, 0)), 60) + Caml_format.caml_int_of_string(Caml_array.get(arr, 1)) | 0;
}

function getSurgeStrategyTypes(param) {
  return List.map((function (strategyName) {
                return {
                        key: strategyName.toLowerCase(),
                        value: strategyName,
                        text: strategyName
                      };
              }), SurgeStrategy.getListOfStrategyTypes(undefined));
}

function getWeekDays(param) {
  return List.map((function (weekday) {
                return {
                        id: Weekday.toString(weekday),
                        label: Weekday.toString(weekday),
                        value: Weekday.toString(weekday)
                      };
              }), Weekday.getListOfDaysOfWeek(undefined));
}

function getZoneDescription(zoneId, zoneData) {
  return List.find((function (zone) {
                return Caml_format.caml_int_of_string(zoneId) === zone.id;
              }), zoneData).description;
}

function getZoneSelectDisplayData(zones, zoneData) {
  var displayStr = List.length(zones) > 0 ? String(List.length(zones)) + (" zones selected: " + List.fold_left((function (display, zone) {
              return getZoneDescription(zone, zoneData) + (", " + display);
            }), "", zones)) : "";
  if (displayStr.length > 10) {
    return $$String.sub(displayStr, 0, 20) + "...";
  } else {
    return displayStr;
  }
}

var NewCampaignHelper = {
  convertTimeToMinutes: convertTimeToMinutes,
  getSurgeStrategyTypes: getSurgeStrategyTypes,
  getWeekDays: getWeekDays,
  getZoneDescription: getZoneDescription,
  getZoneSelectDisplayData: getZoneSelectDisplayData
};

var validators_zoneStrategy = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.zoneStrategy
                    }), (function (strategy) {
                    return {
                            TAG: /* Ok */0,
                            _0: SurgeZoneStrategy.fromString(strategy)
                          };
                  }));
    })
};

var validators_zones = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var zoneStrategy = param.zoneStrategy;
      var zones = param.zones;
      if (zoneStrategy === "") {
        return {
                TAG: /* Ok */0,
                _0: List.map(Caml_format.caml_int_of_string, zones)
              };
      }
      var match = SurgeZoneStrategy.fromString(zoneStrategy);
      if (match) {
        if (zones) {
          return {
                  TAG: /* Ok */0,
                  _0: List.map(Caml_format.caml_int_of_string, zones)
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Please select zones"
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: List.map(Caml_format.caml_int_of_string, zones)
              };
      }
    })
};

var validators_weekdays = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var weekdays = param.weekdays;
      if (weekdays) {
        return {
                TAG: /* Ok */0,
                _0: List.map(Weekday.fromString, weekdays)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select one or more weekdays to repeat campaign on"
              };
      }
    })
};

var validators_vehicleIds = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var vehicleIds = param.vehicleIds;
      if (vehicleIds) {
        return {
                TAG: /* Ok */0,
                _0: List.map(Caml_format.caml_int_of_string, vehicleIds)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select one or more vehicles types to apply campaign on"
              };
      }
    })
};

var validators_priority = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      return PrimitiveFormTypes$Catalyst.getValue({
                  TAG: /* Int */2,
                  _0: param.priority
                });
    })
};

var validators_strategyVal = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var surgeStrategy = param.surgeStrategy;
      if (surgeStrategy === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please select a surge strategy"
              };
      }
      var strategyVal = param.strategyVal;
      var match = surgeStrategy.value;
      switch (match) {
        case "Negative Flat" :
            return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                            TAG: /* Int */2,
                            _0: strategyVal
                          }), (function (amount) {
                          if (amount < 1 || amount > 500) {
                            return {
                                    TAG: /* Error */1,
                                    _0: "Please enter Negative Flat Surge value between INR 1 and 500"
                                  };
                          } else {
                            return {
                                    TAG: /* Ok */0,
                                    _0: {
                                      TAG: /* Flat */0,
                                      _0: amount
                                    }
                                  };
                          }
                        }));
        case "Negative Multiplier" :
            return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                            TAG: /* Float */3,
                            _0: strategyVal
                          }), (function (value) {
                          if (value < 0.5 || value >= 1.0) {
                            return {
                                    TAG: /* Error */1,
                                    _0: "Please enter Negative surge multiplier value greater than or equal to 0.5 and less than 1.0"
                                  };
                          }
                          var regex = /^\d+\.\d{1,2}$/;
                          var validationResult = regex.test(strategyVal);
                          if (validationResult) {
                            return {
                                    TAG: /* Ok */0,
                                    _0: {
                                      TAG: /* Multiplier */1,
                                      _0: value
                                    }
                                  };
                          } else {
                            return {
                                    TAG: /* Error */1,
                                    _0: "Please enter Negative surge multiplier value upto two decimal places"
                                  };
                          }
                        }));
        case "Positive Flat" :
            return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                            TAG: /* Int */2,
                            _0: strategyVal
                          }), (function (amount) {
                          if (amount < 1 || amount > 1000) {
                            return {
                                    TAG: /* Error */1,
                                    _0: "Please enter a flat surge value between 1 and 1000"
                                  };
                          } else {
                            return {
                                    TAG: /* Ok */0,
                                    _0: {
                                      TAG: /* Flat */0,
                                      _0: amount
                                    }
                                  };
                          }
                        }));
        case "Positive Multiplier" :
            return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                            TAG: /* Float */3,
                            _0: strategyVal
                          }), (function (value) {
                          if (value <= 1.0 || value > 3.0) {
                            return {
                                    TAG: /* Error */1,
                                    _0: "Please enter a surge multiplier value greater than 1.0 and less than or equal to 3.0"
                                  };
                          } else {
                            return {
                                    TAG: /* Ok */0,
                                    _0: {
                                      TAG: /* Multiplier */1,
                                      _0: value
                                    }
                                  };
                          }
                        }));
        default:
          return {
                  TAG: /* Error */1,
                  _0: "Please select a surge strategy"
                };
      }
    })
};

var validators_surgeStrategy = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var surgeStrategy = param.surgeStrategy;
      if (surgeStrategy !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: surgeStrategy.value
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select a surge strategy"
              };
      }
    })
};

var validators_campaignName = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      return PrimitiveFormTypes$Catalyst.getValue({
                  TAG: /* String */1,
                  _0: param.campaignName
                });
    })
};

var validators = {
  zoneStrategy: validators_zoneStrategy,
  zones: validators_zones,
  weekdays: validators_weekdays,
  vehicleIds: validators_vehicleIds,
  priority: validators_priority,
  strategyVal: validators_strategyVal,
  surgeStrategy: validators_surgeStrategy,
  endWindow: undefined,
  startWindow: undefined,
  endDate: undefined,
  startDate: undefined,
  campaignName: validators_campaignName
};

function initialFieldsStatuses(_input) {
  return {
          zoneStrategy: /* Pristine */0,
          zones: /* Pristine */0,
          weekdays: /* Pristine */0,
          vehicleIds: /* Pristine */0,
          priority: /* Pristine */0,
          strategyVal: /* Pristine */0,
          surgeStrategy: /* Pristine */0,
          endWindow: /* Pristine */0,
          startWindow: /* Pristine */0,
          endDate: /* Pristine */0,
          startDate: /* Pristine */0,
          campaignName: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.zoneStrategy;
  var match_0 = match ? match._0 : Curry._1(validators.zoneStrategy.validate, input);
  var match$1 = fieldsStatuses.zones;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.zones.validate, input);
  var match$2 = fieldsStatuses.weekdays;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.weekdays.validate, input);
  var match$3 = fieldsStatuses.vehicleIds;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.vehicleIds.validate, input);
  var match$4 = fieldsStatuses.priority;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.priority.validate, input);
  var match$5 = fieldsStatuses.strategyVal;
  var match_0$5 = match$5 ? match$5._0 : Curry._1(validators.strategyVal.validate, input);
  var match$6 = fieldsStatuses.surgeStrategy;
  var match_0$6 = match$6 ? match$6._0 : Curry._1(validators.surgeStrategy.validate, input);
  var match_0$7 = {
    TAG: /* Ok */0,
    _0: input.endWindow
  };
  var match_0$8 = {
    TAG: /* Ok */0,
    _0: input.startWindow
  };
  var match_0$9 = {
    TAG: /* Ok */0,
    _0: input.endDate
  };
  var match_0$10 = {
    TAG: /* Ok */0,
    _0: input.startDate
  };
  var match$7 = fieldsStatuses.campaignName;
  var match_0$11 = match$7 ? match$7._0 : Curry._1(validators.campaignName.validate, input);
  var zoneStrategyResult = match_0;
  var zoneStrategyResult$1;
  if (zoneStrategyResult.TAG === /* Ok */0) {
    var zonesResult = match_0$1;
    if (zonesResult.TAG === /* Ok */0) {
      var weekdaysResult = match_0$2;
      if (weekdaysResult.TAG === /* Ok */0) {
        var vehicleIdsResult = match_0$3;
        if (vehicleIdsResult.TAG === /* Ok */0) {
          var priorityResult = match_0$4;
          if (priorityResult.TAG === /* Ok */0) {
            var strategyValResult = match_0$5;
            if (strategyValResult.TAG === /* Ok */0) {
              var surgeStrategyResult = match_0$6;
              if (surgeStrategyResult.TAG === /* Ok */0) {
                var endWindowResult = match_0$7;
                if (endWindowResult.TAG === /* Ok */0) {
                  var startWindowResult = match_0$8;
                  if (startWindowResult.TAG === /* Ok */0) {
                    var endDateResult = match_0$9;
                    if (endDateResult.TAG === /* Ok */0) {
                      var startDateResult = match_0$10;
                      if (startDateResult.TAG === /* Ok */0) {
                        var campaignNameResult = match_0$11;
                        if (campaignNameResult.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Valid */0,
                                  output: {
                                    campaignName: campaignNameResult._0,
                                    startDate: startDateResult._0,
                                    endDate: endDateResult._0,
                                    startWindow: startWindowResult._0,
                                    endWindow: endWindowResult._0,
                                    surgeStrategy: surgeStrategyResult._0,
                                    strategyVal: strategyValResult._0,
                                    priority: priorityResult._0,
                                    vehicleIds: vehicleIdsResult._0,
                                    weekdays: weekdaysResult._0,
                                    zones: zonesResult._0,
                                    zoneStrategy: zoneStrategyResult._0
                                  },
                                  fieldsStatuses: {
                                    zoneStrategy: /* Dirty */{
                                      _0: zoneStrategyResult,
                                      _1: /* Shown */0
                                    },
                                    zones: /* Dirty */{
                                      _0: zonesResult,
                                      _1: /* Shown */0
                                    },
                                    weekdays: /* Dirty */{
                                      _0: weekdaysResult,
                                      _1: /* Shown */0
                                    },
                                    vehicleIds: /* Dirty */{
                                      _0: vehicleIdsResult,
                                      _1: /* Shown */0
                                    },
                                    priority: /* Dirty */{
                                      _0: priorityResult,
                                      _1: /* Shown */0
                                    },
                                    strategyVal: /* Dirty */{
                                      _0: strategyValResult,
                                      _1: /* Shown */0
                                    },
                                    surgeStrategy: /* Dirty */{
                                      _0: surgeStrategyResult,
                                      _1: /* Shown */0
                                    },
                                    endWindow: /* Dirty */{
                                      _0: endWindowResult,
                                      _1: /* Hidden */1
                                    },
                                    startWindow: /* Dirty */{
                                      _0: startWindowResult,
                                      _1: /* Hidden */1
                                    },
                                    endDate: /* Dirty */{
                                      _0: endDateResult,
                                      _1: /* Hidden */1
                                    },
                                    startDate: /* Dirty */{
                                      _0: startDateResult,
                                      _1: /* Hidden */1
                                    },
                                    campaignName: /* Dirty */{
                                      _0: campaignNameResult,
                                      _1: /* Shown */0
                                    }
                                  },
                                  collectionsStatuses: undefined
                                };
                        }
                        zoneStrategyResult$1 = zoneStrategyResult;
                      } else {
                        zoneStrategyResult$1 = zoneStrategyResult;
                      }
                    } else {
                      zoneStrategyResult$1 = zoneStrategyResult;
                    }
                  } else {
                    zoneStrategyResult$1 = zoneStrategyResult;
                  }
                } else {
                  zoneStrategyResult$1 = zoneStrategyResult;
                }
              } else {
                zoneStrategyResult$1 = zoneStrategyResult;
              }
            } else {
              zoneStrategyResult$1 = zoneStrategyResult;
            }
          } else {
            zoneStrategyResult$1 = zoneStrategyResult;
          }
        } else {
          zoneStrategyResult$1 = zoneStrategyResult;
        }
      } else {
        zoneStrategyResult$1 = zoneStrategyResult;
      }
    } else {
      zoneStrategyResult$1 = zoneStrategyResult;
    }
  } else {
    zoneStrategyResult$1 = zoneStrategyResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            zoneStrategy: /* Dirty */{
              _0: zoneStrategyResult$1,
              _1: /* Shown */0
            },
            zones: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            weekdays: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            vehicleIds: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            priority: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            strategyVal: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            surgeStrategy: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            },
            endWindow: /* Dirty */{
              _0: match_0$7,
              _1: /* Hidden */1
            },
            startWindow: /* Dirty */{
              _0: match_0$8,
              _1: /* Hidden */1
            },
            endDate: /* Dirty */{
              _0: match_0$9,
              _1: /* Hidden */1
            },
            startDate: /* Dirty */{
              _0: match_0$10,
              _1: /* Hidden */1
            },
            campaignName: /* Dirty */{
              _0: match_0$11,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurZoneStrategyField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.zoneStrategy, validators_zoneStrategy, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: status,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurZonesField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.zones, validators_zones, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: status,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurWeekdaysField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.weekdays, validators_weekdays, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: status,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurVehicleIdsField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.vehicleIds, validators_vehicleIds, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: status,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPriorityField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.priority, validators_priority, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: status,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStrategyValField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.strategyVal, validators_strategyVal, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: status,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSurgeStrategyField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.surgeStrategy, validators_surgeStrategy, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: status,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEndWindowField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithoutValidator(state.input.endWindow, state.fieldsStatuses.endWindow, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: status,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartWindowField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithoutValidator(state.input.startWindow, state.fieldsStatuses.startWindow, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: status,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEndDateField */9 :
                  var result$9 = Formality.validateFieldOnBlurWithoutValidator(state.input.endDate, state.fieldsStatuses.endDate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: status,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$9 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$9,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartDateField */10 :
                  var result$10 = Formality.validateFieldOnBlurWithoutValidator(state.input.startDate, state.fieldsStatuses.startDate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: status,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$10 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$10,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCampaignNameField */11 :
                  var result$11 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.campaignName, validators_campaignName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: status
                                };
                        }));
                  if (result$11 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$11,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */12 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */12,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */13,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */15);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */14);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */13 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */14 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */15 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateZoneStrategyField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$12 = Formality.validateDependentFieldOnChange(nextInput, nextFieldsStatuses.contents.zones, validators_zones, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: status,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$12 !== undefined) {
                    nextFieldsStatuses.contents = result$12;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, nextFieldsStatuses.contents.zoneStrategy, state.submissionStatus, validators_zoneStrategy, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            zoneStrategy: status,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateZonesField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.zones, state.submissionStatus, validators_zones, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: status,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateWeekdaysField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.weekdays, state.submissionStatus, validators_weekdays, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: status,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateVehicleIdsField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.vehicleIds, state.submissionStatus, validators_vehicleIds, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: status,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePriorityField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.priority, state.submissionStatus, validators_priority, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: status,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStrategyValField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$13 = Formality.validateDependentFieldOnChange(nextInput$5, nextFieldsStatuses$1.contents.surgeStrategy, validators_surgeStrategy, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: init.strategyVal,
                                  surgeStrategy: status,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$13 !== undefined) {
                    nextFieldsStatuses$1.contents = result$13;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, nextFieldsStatuses$1.contents.strategyVal, state.submissionStatus, validators_strategyVal, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: status,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSurgeStrategyField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$2 = {
                    contents: state.fieldsStatuses
                  };
                  var result$14 = Formality.validateDependentFieldOnChange(nextInput$6, nextFieldsStatuses$2.contents.strategyVal, validators_strategyVal, (function (status) {
                          var init = nextFieldsStatuses$2.contents;
                          return {
                                  zoneStrategy: init.zoneStrategy,
                                  zones: init.zones,
                                  weekdays: init.weekdays,
                                  vehicleIds: init.vehicleIds,
                                  priority: init.priority,
                                  strategyVal: status,
                                  surgeStrategy: init.surgeStrategy,
                                  endWindow: init.endWindow,
                                  startWindow: init.startWindow,
                                  endDate: init.endDate,
                                  startDate: init.startDate,
                                  campaignName: init.campaignName
                                };
                        }));
                  if (result$14 !== undefined) {
                    nextFieldsStatuses$2.contents = result$14;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$6, nextFieldsStatuses$2.contents.surgeStrategy, state.submissionStatus, validators_surgeStrategy, (function (status) {
                                    var init = nextFieldsStatuses$2.contents;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: status,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEndWindowField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$7.endWindow, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: status,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartWindowField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$8.startWindow, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: status,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEndDateField */9 :
                  var nextInput$9 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$9,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$9.endDate, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: status,
                                            startDate: init.startDate,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartDateField */10 :
                  var nextInput$10 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$10,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$10.startDate, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: status,
                                            campaignName: init.campaignName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCampaignNameField */11 :
                  var nextInput$11 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$11,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$11, state.fieldsStatuses.campaignName, state.submissionStatus, validators_campaignName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zoneStrategy: init.zoneStrategy,
                                            zones: init.zones,
                                            weekdays: init.weekdays,
                                            vehicleIds: init.vehicleIds,
                                            priority: init.priority,
                                            strategyVal: init.strategyVal,
                                            surgeStrategy: init.surgeStrategy,
                                            endWindow: init.endWindow,
                                            startWindow: init.startWindow,
                                            endDate: init.endDate,
                                            startDate: init.startDate,
                                            campaignName: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */12 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */13 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */14 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateZoneStrategy: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateZoneStrategyField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateZones: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateZonesField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateWeekdays: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateWeekdaysField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateVehicleIds: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateVehicleIdsField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePriority: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePriorityField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStrategyVal: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStrategyValField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSurgeStrategy: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSurgeStrategyField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEndWindow: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEndWindowField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStartWindow: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStartWindowField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEndDate: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEndDateField */9,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStartDate: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStartDateField */10,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCampaignName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCampaignNameField */11,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurZoneStrategy: (function (param) {
              return Curry._1(dispatch, /* BlurZoneStrategyField */0);
            }),
          blurZones: (function (param) {
              return Curry._1(dispatch, /* BlurZonesField */1);
            }),
          blurWeekdays: (function (param) {
              return Curry._1(dispatch, /* BlurWeekdaysField */2);
            }),
          blurVehicleIds: (function (param) {
              return Curry._1(dispatch, /* BlurVehicleIdsField */3);
            }),
          blurPriority: (function (param) {
              return Curry._1(dispatch, /* BlurPriorityField */4);
            }),
          blurStrategyVal: (function (param) {
              return Curry._1(dispatch, /* BlurStrategyValField */5);
            }),
          blurSurgeStrategy: (function (param) {
              return Curry._1(dispatch, /* BlurSurgeStrategyField */6);
            }),
          blurEndWindow: (function (param) {
              return Curry._1(dispatch, /* BlurEndWindowField */7);
            }),
          blurStartWindow: (function (param) {
              return Curry._1(dispatch, /* BlurStartWindowField */8);
            }),
          blurEndDate: (function (param) {
              return Curry._1(dispatch, /* BlurEndDateField */9);
            }),
          blurStartDate: (function (param) {
              return Curry._1(dispatch, /* BlurStartDateField */10);
            }),
          blurCampaignName: (function (param) {
              return Curry._1(dispatch, /* BlurCampaignNameField */11);
            }),
          zoneStrategyResult: Formality.exposeFieldResult(state.fieldsStatuses.zoneStrategy),
          zonesResult: Formality.exposeFieldResult(state.fieldsStatuses.zones),
          weekdaysResult: Formality.exposeFieldResult(state.fieldsStatuses.weekdays),
          vehicleIdsResult: Formality.exposeFieldResult(state.fieldsStatuses.vehicleIds),
          priorityResult: Formality.exposeFieldResult(state.fieldsStatuses.priority),
          strategyValResult: Formality.exposeFieldResult(state.fieldsStatuses.strategyVal),
          surgeStrategyResult: Formality.exposeFieldResult(state.fieldsStatuses.surgeStrategy),
          endWindowResult: Formality.exposeFieldResult(state.fieldsStatuses.endWindow),
          startWindowResult: Formality.exposeFieldResult(state.fieldsStatuses.startWindow),
          endDateResult: Formality.exposeFieldResult(state.fieldsStatuses.endDate),
          startDateResult: Formality.exposeFieldResult(state.fieldsStatuses.startDate),
          campaignNameResult: Formality.exposeFieldResult(state.fieldsStatuses.campaignName),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (!match.zoneStrategy && !match.zones && !match.weekdays && !match.vehicleIds && !match.priority && !match.strategyVal && !match.surgeStrategy && !match.endWindow && !match.startWindow && !match.endDate && !match.startDate && !match.campaignName) {
                return false;
              }
              return true;
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */12);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */13);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */14);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */14,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */15);
            })
        };
}

var NewCampaignForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function NewCampaignFormComponent(Props) {
  var onRefresh = Props.onRefresh;
  var onToggle = Props.onToggle;
  var vehicleTypes = Props.vehicleTypes;
  var geoRegion = Props.geoRegion;
  var zoneData = Props.zoneData;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setRequestStatus = match$1[1];
  var requestStatus = match$1[0];
  var initialInput_startDate = DateTime$Catalyst.now(undefined);
  var initialInput_endDate = DateTime$Catalyst.now(undefined);
  var initialInput_startWindow = DateTime$Catalyst.fromString("h:mm", "10:00");
  var initialInput_endWindow = DateTime$Catalyst.fromString("h:mm", "12:00");
  var initialInput = {
    campaignName: "",
    startDate: initialInput_startDate,
    endDate: initialInput_endDate,
    startWindow: initialInput_startWindow,
    endWindow: initialInput_endWindow,
    surgeStrategy: undefined,
    strategyVal: "",
    priority: "1",
    vehicleIds: /* [] */0,
    weekdays: /* [] */0,
    zones: /* [] */0,
    zoneStrategy: "All"
  };
  var form = useForm(initialInput, (function (param, submissionCbs) {
          var zones = param.zones;
          var weekdays = param.weekdays;
          var vehicleIds = param.vehicleIds;
          var priority = param.priority;
          var strategyVal = param.strategyVal;
          var surgeStrategy = param.surgeStrategy;
          var endWindow = param.endWindow;
          var startWindow = param.startWindow;
          var endDate = param.endDate;
          var startDate = param.startDate;
          var campaignName = param.campaignName;
          var RepoInstance = CrmRepoManager.getSurgeRepo(undefined);
          Curry._1(setRequestStatus, (function (param) {
                  return {
                          TAG: /* Loading */0,
                          _0: undefined
                        };
                }));
          return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                        var tmp;
                        switch (surgeStrategy) {
                          case "Negative Flat" :
                              tmp = strategyVal.TAG === /* Flat */0 ? ({
                                    TAG: /* Flat */0,
                                    _0: Math.imul(-1, strategyVal._0)
                                  }) : ({
                                    TAG: /* Multiplier */1,
                                    _0: strategyVal._0
                                  });
                              break;
                          case "Negative Multiplier" :
                              tmp = strategyVal.TAG === /* Flat */0 ? ({
                                    TAG: /* Flat */0,
                                    _0: strategyVal._0
                                  }) : ({
                                    TAG: /* Multiplier */1,
                                    _0: strategyVal._0
                                  });
                              break;
                          default:
                            tmp = strategyVal;
                        }
                        return Curry._2(RepoInstance.createCampaign, {
                                    campaignName: campaignName,
                                    startDate: startDate,
                                    endDate: endDate,
                                    startWindow: DateTime$Catalyst.toMinute(startWindow),
                                    endWindow: DateTime$Catalyst.toMinute(endWindow),
                                    surgeStrategy: tmp,
                                    priority: priority,
                                    geoRegionId: geoRegion.id,
                                    vehicleTypesIds: vehicleIds,
                                    weekdays: weekdays,
                                    zones: zones
                                  }, country);
                      }), (function (data) {
                        Curry._1(setRequestStatus, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                        return Curry._1(submissionCbs.notifyOnSuccess, undefined);
                      }), (function (error) {
                        Curry._1(setRequestStatus, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                        Curry._1(submissionCbs.notifyOnFailure, undefined);
                        return Curry._1(submissionCbs.dismissSubmissionResult, undefined);
                      }));
        }));
  var buildForm = function (error, isLoadingOpt, param) {
    var isLoading = isLoadingOpt !== undefined ? isLoadingOpt : false;
    var surgeStrategy = form.input.surgeStrategy;
    var tmp;
    if (surgeStrategy !== undefined) {
      var match = surgeStrategy.value;
      switch (match) {
        case "Negative Flat" :
            tmp = React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Negative Flat Surge", (function ($$event) {
                          return Curry._2(form.updateStrategyVal, (function (input, value) {
                                        return {
                                                campaignName: input.campaignName,
                                                startDate: input.startDate,
                                                endDate: input.endDate,
                                                startWindow: input.startWindow,
                                                endWindow: input.endWindow,
                                                surgeStrategy: input.surgeStrategy,
                                                strategyVal: value,
                                                priority: input.priority,
                                                vehicleIds: input.vehicleIds,
                                                weekdays: input.weekdays,
                                                zones: input.zones,
                                                zoneStrategy: input.zoneStrategy
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), form.submitting, undefined, "Enter amount like 25 50..", undefined, undefined, undefined, form.strategyValResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.strategyVal
                  }
                });
            break;
        case "Negative Multiplier" :
            tmp = React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Negative Multiplier Surge", (function ($$event) {
                          return Curry._2(form.updateStrategyVal, (function (input, value) {
                                        return {
                                                campaignName: input.campaignName,
                                                startDate: input.startDate,
                                                endDate: input.endDate,
                                                startWindow: input.startWindow,
                                                endWindow: input.endWindow,
                                                surgeStrategy: input.surgeStrategy,
                                                strategyVal: value,
                                                priority: input.priority,
                                                vehicleIds: input.vehicleIds,
                                                weekdays: input.weekdays,
                                                zones: input.zones,
                                                zoneStrategy: input.zoneStrategy
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), form.submitting, undefined, "Enter value like 1 1.2..", undefined, undefined, undefined, form.strategyValResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.strategyVal
                  }
                });
            break;
        case "Positive Flat" :
            tmp = React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Positive Flat Surge", (function ($$event) {
                          return Curry._2(form.updateStrategyVal, (function (input, value) {
                                        return {
                                                campaignName: input.campaignName,
                                                startDate: input.startDate,
                                                endDate: input.endDate,
                                                startWindow: input.startWindow,
                                                endWindow: input.endWindow,
                                                surgeStrategy: input.surgeStrategy,
                                                strategyVal: value,
                                                priority: input.priority,
                                                vehicleIds: input.vehicleIds,
                                                weekdays: input.weekdays,
                                                zones: input.zones,
                                                zoneStrategy: input.zoneStrategy
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), form.submitting, undefined, "Enter amount like 25 50..", undefined, undefined, undefined, form.strategyValResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.strategyVal
                  }
                });
            break;
        case "Positive Multiplier" :
            tmp = React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Positive Multiplier Surge", (function ($$event) {
                          return Curry._2(form.updateStrategyVal, (function (input, value) {
                                        return {
                                                campaignName: input.campaignName,
                                                startDate: input.startDate,
                                                endDate: input.endDate,
                                                startWindow: input.startWindow,
                                                endWindow: input.endWindow,
                                                surgeStrategy: input.surgeStrategy,
                                                strategyVal: value,
                                                priority: input.priority,
                                                vehicleIds: input.vehicleIds,
                                                weekdays: input.weekdays,
                                                zones: input.zones,
                                                zoneStrategy: input.zoneStrategy
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), form.submitting, undefined, "Enter value like 1 1.2..", undefined, undefined, undefined, form.strategyValResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.strategyVal
                  }
                });
            break;
        default:
          tmp = null;
      }
    } else {
      tmp = null;
    }
    var match$1 = SurgeZoneStrategy.fromString(form.input.zoneStrategy);
    return React.createElement("form", {
                className: "porter-form u-scrollable-y u-form-body-height",
                onSubmit: (function ($$event) {
                    $$event.preventDefault();
                    return Curry._1(form.submit, undefined);
                  })
              }, React.createElement("div", {
                    className: "porter-form__section"
                  }, React.createElement(Row$Catalyst.make, {
                        children: React.createElement(FormTextInput$Catalyst.make, {
                              input_props: FormInput$Catalyst.make_props("Campaign Name", (function ($$event) {
                                      return Curry._2(form.updateCampaignName, (function (input, value) {
                                                    return {
                                                            campaignName: value,
                                                            startDate: input.startDate,
                                                            endDate: input.endDate,
                                                            startWindow: input.startWindow,
                                                            endWindow: input.endWindow,
                                                            surgeStrategy: input.surgeStrategy,
                                                            strategyVal: input.strategyVal,
                                                            priority: input.priority,
                                                            vehicleIds: input.vehicleIds,
                                                            weekdays: input.weekdays,
                                                            zones: input.zones,
                                                            zoneStrategy: input.zoneStrategy
                                                          };
                                                  }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                    }), form.submitting, undefined, undefined, undefined, undefined, undefined, form.campaignNameResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                              textinput_props: {
                                value: form.input.campaignName
                              }
                            })
                      }), React.createElement(Row$Catalyst.make, {
                        children: null
                      }, React.createElement(FormSelectInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Surge Strategy", (function ($$event) {
                                    return Curry._2(form.updateSurgeStrategy, (function (input, value) {
                                                  return {
                                                          campaignName: input.campaignName,
                                                          startDate: input.startDate,
                                                          endDate: input.endDate,
                                                          startWindow: input.startWindow,
                                                          endWindow: input.endWindow,
                                                          surgeStrategy: value,
                                                          strategyVal: "",
                                                          priority: input.priority,
                                                          vehicleIds: input.vehicleIds,
                                                          weekdays: input.weekdays,
                                                          zones: input.zones,
                                                          zoneStrategy: input.zoneStrategy
                                                        };
                                                }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), getSurgeStrategyTypes(undefined)));
                                  }), form.submitting, undefined, undefined, undefined, undefined, undefined, form.surgeStrategyResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            select_props: {
                              value: form.input.surgeStrategy,
                              items: getSurgeStrategyTypes(undefined),
                              isNoneRequired: true
                            }
                          }), tmp)), React.createElement("div", {
                    className: "porter-form__section"
                  }, React.createElement(Row$Catalyst.make, {
                        children: null
                      }, React.createElement(FormDateInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Start Date", (function (param) {
                                    
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, form.startDateResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            date_props: {
                              value: Caml_option.some(form.input.startDate),
                              minDate: undefined,
                              maxDate: undefined,
                              onChange: (function (date) {
                                  return Curry._2(form.updateStartDate, (function (input, value) {
                                                return {
                                                        campaignName: input.campaignName,
                                                        startDate: value,
                                                        endDate: input.endDate,
                                                        startWindow: input.startWindow,
                                                        endWindow: input.endWindow,
                                                        surgeStrategy: input.surgeStrategy,
                                                        strategyVal: input.strategyVal,
                                                        priority: input.priority,
                                                        vehicleIds: input.vehicleIds,
                                                        weekdays: input.weekdays,
                                                        zones: input.zones,
                                                        zoneStrategy: input.zoneStrategy
                                                      };
                                              }), date);
                                }),
                              format: "dd/MM/YYYY",
                              autoOk: false,
                              views: [
                                "year",
                                "month",
                                "date"
                              ]
                            }
                          }), React.createElement(FormDateInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("End Date", (function (param) {
                                    
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, form.endDateResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            date_props: {
                              value: Caml_option.some(form.input.endDate),
                              minDate: undefined,
                              maxDate: undefined,
                              onChange: (function (date) {
                                  return Curry._2(form.updateEndDate, (function (input, value) {
                                                return {
                                                        campaignName: input.campaignName,
                                                        startDate: input.startDate,
                                                        endDate: value,
                                                        startWindow: input.startWindow,
                                                        endWindow: input.endWindow,
                                                        surgeStrategy: input.surgeStrategy,
                                                        strategyVal: input.strategyVal,
                                                        priority: input.priority,
                                                        vehicleIds: input.vehicleIds,
                                                        weekdays: input.weekdays,
                                                        zones: input.zones,
                                                        zoneStrategy: input.zoneStrategy
                                                      };
                                              }), date);
                                }),
                              format: "dd/MM/YYYY",
                              autoOk: false,
                              views: [
                                "year",
                                "month",
                                "date"
                              ]
                            }
                          })), React.createElement(Row$Catalyst.make, {
                        children: null
                      }, React.createElement(FormTimeInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Start Window", (function (param) {
                                    
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, form.startWindowResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            time_props: {
                              value: Caml_option.some(form.input.startWindow),
                              onChange: (function (datetime) {
                                  return Curry._2(form.updateStartWindow, (function (input, value) {
                                                return {
                                                        campaignName: input.campaignName,
                                                        startDate: input.startDate,
                                                        endDate: input.endDate,
                                                        startWindow: value,
                                                        endWindow: input.endWindow,
                                                        surgeStrategy: input.surgeStrategy,
                                                        strategyVal: input.strategyVal,
                                                        priority: input.priority,
                                                        vehicleIds: input.vehicleIds,
                                                        weekdays: input.weekdays,
                                                        zones: input.zones,
                                                        zoneStrategy: input.zoneStrategy
                                                      };
                                              }), datetime);
                                })
                            }
                          }), React.createElement(FormTimeInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("End Window", (function (param) {
                                    
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, form.startWindowResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            time_props: {
                              value: Caml_option.some(form.input.endWindow),
                              onChange: (function (datetime) {
                                  return Curry._2(form.updateEndWindow, (function (input, value) {
                                                return {
                                                        campaignName: input.campaignName,
                                                        startDate: input.startDate,
                                                        endDate: input.endDate,
                                                        startWindow: input.startWindow,
                                                        endWindow: value,
                                                        surgeStrategy: input.surgeStrategy,
                                                        strategyVal: input.strategyVal,
                                                        priority: input.priority,
                                                        vehicleIds: input.vehicleIds,
                                                        weekdays: input.weekdays,
                                                        zones: input.zones,
                                                        zoneStrategy: input.zoneStrategy
                                                      };
                                              }), datetime);
                                })
                            }
                          })), React.createElement(FormCheckBoxInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("Repeat On", (function ($$event) {
                                return Curry._2(form.updateWeekdays, (function (input, value) {
                                              return {
                                                      campaignName: input.campaignName,
                                                      startDate: input.startDate,
                                                      endDate: input.endDate,
                                                      startWindow: input.startWindow,
                                                      endWindow: input.endWindow,
                                                      surgeStrategy: input.surgeStrategy,
                                                      strategyVal: input.strategyVal,
                                                      priority: input.priority,
                                                      vehicleIds: input.vehicleIds,
                                                      weekdays: value,
                                                      zones: input.zones,
                                                      zoneStrategy: input.zoneStrategy
                                                    };
                                            }), CheckBoxGroup$Catalyst.isChecked(form.input.weekdays, FormHelper$Catalyst.TargetEventWrapper.value($$event)) ? List.filter(function (a) {
                                                    return a !== FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                                  })(form.input.weekdays) : ({
                                                hd: FormHelper$Catalyst.TargetEventWrapper.value($$event),
                                                tl: form.input.weekdays
                                              }));
                              }), undefined, undefined, undefined, undefined, undefined, undefined, form.weekdaysResult, undefined, "max-width", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                        checkbox_props: {
                          selected: form.input.weekdays,
                          options: getWeekDays(undefined),
                          row_layout: true
                        }
                      })), React.createElement("div", {
                    className: "porter-form__section"
                  }, React.createElement(Row$Catalyst.make, {
                        children: null
                      }, React.createElement(FormTextInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Priority", (function ($$event) {
                                    return Curry._2(form.updatePriority, (function (input, value) {
                                                  return {
                                                          campaignName: input.campaignName,
                                                          startDate: input.startDate,
                                                          endDate: input.endDate,
                                                          startWindow: input.startWindow,
                                                          endWindow: input.endWindow,
                                                          surgeStrategy: input.surgeStrategy,
                                                          strategyVal: input.strategyVal,
                                                          priority: value,
                                                          vehicleIds: input.vehicleIds,
                                                          weekdays: input.weekdays,
                                                          zones: input.zones,
                                                          zoneStrategy: input.zoneStrategy
                                                        };
                                                }), $$event.target.value);
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, form.priorityResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            textinput_props: {
                              value: form.input.priority
                            }
                          }), React.createElement(FormTextInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("GeoRegion", (function (param) {
                                    
                                  }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            textinput_props: {
                              value: geoRegion.name
                            }
                          })), React.createElement(Row$Catalyst.make, {
                        children: null
                      }, React.createElement(FormRadioGroupInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("Zones", (function ($$event) {
                                    return Curry._2(form.updateZoneStrategy, (function (input, value) {
                                                  return {
                                                          campaignName: input.campaignName,
                                                          startDate: input.startDate,
                                                          endDate: input.endDate,
                                                          startWindow: input.startWindow,
                                                          endWindow: input.endWindow,
                                                          surgeStrategy: input.surgeStrategy,
                                                          strategyVal: input.strategyVal,
                                                          priority: input.priority,
                                                          vehicleIds: input.vehicleIds,
                                                          weekdays: input.weekdays,
                                                          zones: input.zones,
                                                          zoneStrategy: value
                                                        };
                                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                  }), undefined, undefined, undefined, undefined, undefined, undefined, form.zoneStrategyResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            radio_props: {
                              options: List.map((function (strategy) {
                                      return {
                                              label: SurgeZoneStrategy.toString(strategy),
                                              value: SurgeZoneStrategy.toString(strategy)
                                            };
                                    }), SurgeZoneStrategy.getListOfStrategyTypes(undefined)),
                              value: form.input.zoneStrategy,
                              row_layout: false
                            }
                          }), match$1 ? React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                              input_props: FormInput$Catalyst.make_props("Select Zones", (function ($$event) {
                                      return Curry._2(form.updateZones, (function (input, value) {
                                                    return {
                                                            campaignName: input.campaignName,
                                                            startDate: input.startDate,
                                                            endDate: input.endDate,
                                                            startWindow: input.startWindow,
                                                            endWindow: input.endWindow,
                                                            surgeStrategy: input.surgeStrategy,
                                                            strategyVal: input.strategyVal,
                                                            priority: input.priority,
                                                            vehicleIds: input.vehicleIds,
                                                            weekdays: input.weekdays,
                                                            zones: value,
                                                            zoneStrategy: input.zoneStrategy
                                                          };
                                                  }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                                    }), undefined, undefined, undefined, undefined, undefined, undefined, form.zonesResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                              select_props: {
                                selected: form.input.zones,
                                options: List.map((function (zone) {
                                        return {
                                                key: String(zone.id),
                                                value: String(zone.id),
                                                text: zone.description
                                              };
                                      }), zoneData),
                                renderValue: (function (values) {
                                    return getZoneSelectDisplayData(values, zoneData);
                                  })
                              }
                            }) : null)), React.createElement("div", {
                    className: "porter-form__section"
                  }, React.createElement(FormCheckBoxInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("Vehicle Types", (function ($$event) {
                                return Curry._2(form.updateVehicleIds, (function (input, value) {
                                              return {
                                                      campaignName: input.campaignName,
                                                      startDate: input.startDate,
                                                      endDate: input.endDate,
                                                      startWindow: input.startWindow,
                                                      endWindow: input.endWindow,
                                                      surgeStrategy: input.surgeStrategy,
                                                      strategyVal: input.strategyVal,
                                                      priority: input.priority,
                                                      vehicleIds: value,
                                                      weekdays: input.weekdays,
                                                      zones: input.zones,
                                                      zoneStrategy: input.zoneStrategy
                                                    };
                                            }), CheckBoxGroup$Catalyst.isChecked(form.input.vehicleIds, FormHelper$Catalyst.TargetEventWrapper.value($$event)) ? List.filter(function (a) {
                                                    return a !== FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                                  })(form.input.vehicleIds) : ({
                                                hd: FormHelper$Catalyst.TargetEventWrapper.value($$event),
                                                tl: form.input.vehicleIds
                                              }));
                              }), undefined, undefined, undefined, undefined, undefined, undefined, form.vehicleIdsResult, undefined, "max-width", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                        checkbox_props: {
                          selected: form.input.vehicleIds,
                          options: List.map((function (param) {
                                  var id = param.id;
                                  return {
                                          id: String(id),
                                          label: SurgeViewUtils.createVehicleCategoryLabel(param.name, id),
                                          value: String(id)
                                        };
                                }), vehicleTypes),
                          row_layout: true
                        }
                      })), React.createElement(ModalFooter$Catalyst.make, {
                    label: "Submit",
                    isDisabled: form.submitting,
                    cb: (function (param) {
                        return Curry._1(form.submit, undefined);
                      }),
                    error: error
                  }), isLoading ? React.createElement(FixedLoadingViewComponent$Catalyst.make, {}) : null);
  };
  var tmp;
  if (typeof requestStatus === "number") {
    tmp = buildForm(undefined, undefined, undefined);
  } else {
    switch (requestStatus.TAG | 0) {
      case /* Loading */0 :
          tmp = buildForm(undefined, true, undefined);
          break;
      case /* Live */1 :
          tmp = React.createElement("div", undefined, React.createElement(SuccessInfoComponent$Catalyst.make, {
                    message: "The campaign has been successfully created"
                  }), React.createElement("div", {
                    className: "u-text-centre"
                  }, React.createElement(Button$Catalyst.make, {
                        text: "CLOSE",
                        cb: (function (_event) {
                            Curry._1(onToggle, undefined);
                            return Curry._1(onRefresh, undefined);
                          }),
                        className: "driverModal__actionBtn"
                      })));
          break;
      case /* Error */2 :
          tmp = buildForm(requestStatus._0, undefined, undefined);
          break;
      
    }
  }
  return React.createElement("div", {
              className: "porter-form__modal-body"
            }, React.createElement(FormTitleBar$Catalyst.make, {
                  title: "New Campaign",
                  onCloseCb: (function (param) {
                      return Curry._1(onToggle, undefined);
                    })
                }), tmp);
}

var make = NewCampaignFormComponent;

export {
  NewCampaignHelper ,
  NewCampaignForm ,
  make ,
  
}
/* react Not a pure module */
